"use client";

import Link from "@casino/client/components/Link";
import { Button } from "@workspace/frontend-ui";

type Props = {
  href: string;
  bgColor: string;
  label: string;
};

const PlayNowButton: FC<Props> = ({ href, bgColor, label }) => (
  <Link href={href}>
    <Button
      size="sm"
      style={{ color: bgColor }}
      className="bg-white font-normal text-black"
    >
      {label}
    </Button>
  </Link>
);

export default PlayNowButton;
